import { useEffect, useRef } from 'react';
import { usePreviousWithInitial } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

const useRouteLocation = createRouterSelector(
	// there are two possible options to use
	// `pathname+search` or just `key`
	// not using key as it will be updated on hash updates
	// subject to change
	({ location }) => `${location.pathname}?${location.search}`,
);
/**
 * Executes provided callback on navigation
 * Does not react to hash updates
 */
export const useNavigationEffect = (callback: () => void) => {
	const locationKey = useRouteLocation();

	const callbackRef = useRef(callback);
	callbackRef.current = callback;

	const previousLocationKey = usePreviousWithInitial(locationKey);

	// possible improvement: capture and rethrow error in timeout
	// this is not "synchronization" - this is "reaction" similar to "onClick" because it reacts to "onClick" made in different place
	// error throw from useEffect will trigger ErrorBoundary, but error from onClick will not
	// we might need to synchronize their behaviors aka "useSafeEffect" or "useEventEffect"
	useEffect(() => {
		if (previousLocationKey !== locationKey) {
			callbackRef.current();
		}
	}, [previousLocationKey, locationKey]);
};
